import { AdType } from './adbutler/utils/types';
import { AdPlaceholder } from './freestar/components/AdPlaceholder';
import { CustomFreestarAd } from './freestar/components/CustomFreestarAd';
import { FREESTAR_ENABLED_OUTSIDE_PROD, PLACEMENTS_HASH } from './freestar/utils/constants';
import { FreestarPlacementId } from './freestar/utils/types';

export interface RenderAdExtendedProps {
	containerClassname?: string;
	className?: string;
	height?: number;
	ipAddress?: string;
	pageId: number;
	place: number;
	zoneId?: AdType;
	placementId?: FreestarPlacementId;
	sizes?: string;
	width?: number;
	// Required on purpose: an omitted `isProd` would silently ship the DEV/TEST placeholder to prod.
	isProd: boolean;
	showFromWidth?: number;
	hideFromWidth?: number;
	numberOfDifferentZoneImages?: number;
	setNumberOfDifferentZoneImages?: React.Dispatch<React.SetStateAction<number | undefined>>;
}

export const RenderAd = (props: RenderAdExtendedProps) => {
	if (props.placementId) {
		// Freestar is disabled outside prod — render a sized grey placeholder in the reserved space.
		if (!props.isProd && !FREESTAR_ENABLED_OUTSIDE_PROD) {
			return (
				<AdPlaceholder
					placementId={props.placementId}
					place={props.place}
					showFromWidth={props.showFromWidth}
					hideFromWidth={props.hideFromWidth}
					containerClassname={props.containerClassname}
				/>
			);
		}

		const placementInfo = PLACEMENTS_HASH[props.placementId];
		const sizes = placementInfo?.sizes || undefined;
		const publisher = placementInfo?.publisher || undefined;

		return (
			<CustomFreestarAd
				publisher={publisher}
				placementId={props.placementId}
				place={props.place}
				sizes={sizes}
				showFromWidth={props.showFromWidth}
				hideFromWidth={props.hideFromWidth}
				containerClassname={props.containerClassname}
			/>
		);
	}

	// if (props.zoneId) {
	// 	return <AdButlerAdvertisementWrapper {...props} zoneId={props.zoneId} />;
	// }

	return null;
};
